import React from 'react';
import { StackItem, Stack } from '@domain-group/fe-blueprint-ui/layout';
import AverageStarRatingAndTotal, {
  STAR_RATING_SECTION,
} from '../average-star-rating-and-total';
import RmaLogo from '../recommendations/rma-logo';
import * as styles from './recommendation-title.style';
import { useReviewsContext } from '../../recommendations-enquiry-section';
import { OverallStarRating } from '../recommendations/types';

type Props = {
  title: string;
  overallStarRating?: OverallStarRating;
};

const RecommendationTitle = ({
  title,
  overallStarRating,
}: Props): JSX.Element => {
  const { hasReviews } = useReviewsContext();
  if (hasReviews) {
    return (
      <div css={styles.wrapper}>
        <Stack css={styles.container}>
          <StackItem
            as="h3"
            css={styles.heading}
            data-testid="recommendations_title"
          >
            {title} Reviews
          </StackItem>
          {overallStarRating && (
            <div css={styles.ratingsRow}>
              <AverageStarRatingAndTotal
                section={STAR_RATING_SECTION.RECOMMENDATIONS}
                averageRating={overallStarRating.rating}
                totalReviews={overallStarRating.totalReviews}
              />
              <span css={styles.pipe}>|</span>
              <div
                css={styles.reviewsProvided}
                data-testid="recommendations_reviews-provided"
              >
                {overallStarRating.totalReviews} reviews provided by
                <RmaLogo
                  height={20}
                  marginLeft={0}
                  marginBottom={0}
                  marginTop={2}
                />
              </div>
            </div>
          )}
        </Stack>
        <p css={styles.disclaimer}>
          Domain does not make any representation about the accuracy of the
          reviews which are provided by RateMyAgent.
        </p>
      </div>
    );
  }

  return <></>;
};

export default RecommendationTitle;
